/* unplugin-vue-components disabled */import script from "./MessageSourcesAction.vue?vue&type=script&lang=ts&setup=true"
export * from "./MessageSourcesAction.vue?vue&type=script&lang=ts&setup=true"

import "./MessageSourcesAction.vue?vue&type=style&index=0&id=50bb5f7f&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50bb5f7f"]])

export default __exports__